import React, { DetailedHTMLProps, InputHTMLAttributes } from "react";

import classnames from "classnames";

type ModalBodyProps = {} & DetailedHTMLProps<
  InputHTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

const ModalBody = React.forwardRef<HTMLDivElement, ModalBodyProps>(
  ({ children, className, ...props }, ref) => {
    const bodyStyle = classnames(
      className || "pt-2 text-dark-300 text-sm leading-5 px-4 sm:px-6"
    );

    return (
      <div className={bodyStyle} {...props} ref={ref}>
        {children}
      </div>
    );
  }
);

export default React.memo(ModalBody);
